export default "/images/vendor/flag-icon-css/flags/1x1/bn.svg?5fd8c65274736a1b6af4a688b9965a55";